import { components } from "react-select";
import CrossCircleFilledIcon from "app/icons/navigation/CrossCircleFilledIcon";
import { ICON_SIZES } from "app/constants";

const ClearIndicator = ({ ...props }) => (
	<components.ClearIndicator {...props}>
		<CrossCircleFilledIcon height={ICON_SIZES.MD} width={ICON_SIZES.MD} />
	</components.ClearIndicator>
);
export default ClearIndicator;
